import React, { useContext, useEffect, useState, useRef } from 'react';
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'

import { useHideMenu } from '../hooks/useHideMenu';
import { SocketContext } from '../context/SocketContext';

import LoadingOverlay from '../components/LoadingOverlay'


import logoParaTicket from "../assets/femcc-01/logoParaTicket.png";
import logo from "../assets/logo.png";
import { Collapse } from 'react-bootstrap';

const server_url=  process.env.REACT_APP_PRODUCCION;  

let entidad= localStorage.getItem('entidad') || null;
let can = 0
const colores = [
    "success",
    "primary",
    "info",
    "secondary",
    "light",
    // "secondary",
    // "success",
    // "danger",
    // "dark",
    // "warning",
    // "info",
]

const MySwal = withReactContent(Swal);


export const CrearTicket = () => {

    // if( !entidad) {
    //     return <Navigate to="/ingresar" />
    // }

    useHideMenu(true);
    
    // const [size, setSize] = useState('large');
    
    const { socket } = useContext( SocketContext );
    const [ isLoading, setIsLoading ] = useState(false);
    const [ tipoAtencion, setTipoAtencion ] = useState([])
    const [pantalla, setPantalla] = useState(false);
    const [numeroPantalla, setNumeroPantalla] = useState(1);

    const [tipoDocumentoPaso, setTipoDocumentoPaso] = useState("");
    const [numeroDocumentoPaso, setNumeroDocumentoPaso] = useState("");
    const [pacientePaso, setpacientePaso] = useState("");

    const [isTouched, setIsTouched] = useState(false);
    const timeoutRef = useRef(null);

    const handleTouchStart = () => {
        // Inicia un temporizador de 1 segundo
        timeoutRef.current = setTimeout(() => {
        setIsTouched(true);
        }, 500);
    };

    const handleTouchEnd = () => {
        // Limpia el timeout y remueve efecto
        clearTimeout(timeoutRef.current);
        setIsTouched(false);
    };
   
    // const [ticket, setTicket] = useState(null);
    // const [entidadBD, setEntidadBD] = useState(null);
   

    
    const sweet = ( title, html, icon ) =>{ 
        MySwal.fire({ 
            title, 
            html, 
            showConfirmButton: false,
            timer: 15000  
        }) 
    }

    const iconSvg = `
        <svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" viewBox="0 0 64 64" fill="none">
            <circle cx="32" cy="32" r="22" fill="#22C55E" />
            <path d="M18 10 C14 4, 6 10, 10 16" fill="#22C55E"/>
            <path d="M46 10 C50 4, 58 10, 54 16" fill="#22C55E"/>
            <rect x="18" y="50" width="6" height="6" rx="2" fill="#22C55E"/>
            <rect x="40" y="50" width="6" height="6" rx="2" fill="#22C55E"/>
            <rect x="30" y="20" width="4" height="16" rx="2" fill="white"/>
            <circle cx="32" cy="42" r="3" fill="white"/>
        </svg>
    `;

   
     
    const ingresar = () =>{


        let entidadB = document.getElementById('codigoEntidad');
        let codigoEntidad= entidadB.value;
        if(codigoEntidad === "") return sweet("Atención!", 'Falta información', 'error');

        socket.emit('registro-entidad', { codigoEntidad },  ( respuesta ) => {
            
            if(respuesta.length === 0) return false;
            localStorage.setItem('entidad', respuesta[0].codigoEntidad);
            entidad= respuesta[0].codigoEntidad;
            window.location.reload();
            
        })
    }

    useEffect(() => {
        
        async function fetchData() {

            const datos = {
                entidad,

            }
            setIsLoading(true)
            await socket.emit('lista-tipo-atencion-prioridad', datos, ( lista ) => {
                setIsLoading(false)
                setTipoAtencion(lista)
            })
        }

        fetchData();
               
        return () => {
            socket.off('lista-Tipo-Atencion-prioridad')
        }
    }, [])
    

    const continuar = () =>{
        let numeroDocumento = document.getElementById('numeroDocumento');
        let documento= numeroDocumento.value;
        if(documento === "") return sweet("Atención!", 'Falta información', 'error');


        let selectDocumento = document.getElementById("tipoDocumento");
        let tipoDocumento= selectDocumento.value;
        if(tipoDocumento === "") return sweet("Atención!", 'Falta información', 'error');

        setPantalla(!pantalla);
    }

    const pasoPantalla = async ( numeroPantalla ) => {

        let selectDocumento = document.getElementById("tipoDocumento");
        selectDocumento.value= 'CC'
        let tipoDocumento= selectDocumento.value;

        if( numeroPantalla === 1 ) return setNumeroPantalla( numeroPantalla )


        if( numeroPantalla === 2 ) {

            if(tipoDocumento === "") return sweet("Atención!", 'Falta información', 'error');
            let selectedIndex = selectDocumento.selectedIndex;
            let selectedText = selectDocumento.options[selectedIndex].text;

            let numeroDocumento = document.getElementById('numeroDocumento');
            let documento= numeroDocumento.value;
            if(documento === "") return sweet("Atención!", 'Falta información', 'error');

            
            setIsLoading(true)
            const resp = await fetch(`${server_url}/paciente/${entidad}/${documento}`);
            const r =  await resp.json();
            console.log(r.paciente );
            setIsLoading(false)
            setNumeroDocumentoPaso( documento );

            r.paciente.length === 0 ? setpacientePaso( "" ) : setpacientePaso( r.paciente[0].paciente );


            setTipoDocumentoPaso( selectedText )
            setNumeroPantalla( numeroPantalla );

        }

        if( numeroPantalla === 3 ) {

            let numeroDocumento = document.getElementById('numeroDocumento');
            let documento= numeroDocumento.value;
            if(documento === "") return sweet("Atención!", 'Falta información', 'error');

            setNumeroDocumentoPaso( documento );
            console.log(documento);
            
            
            setIsLoading(true)
            const resp = await fetch(`${server_url}/paciente/${entidad}/${documento}`);
            const r =  await resp.json();
            console.log(r.paciente );
            setIsLoading(false)

            r.paciente.length === 0 ? setpacientePaso( "" ) : setpacientePaso( r.paciente[0].paciente );

            // console.log(r.paciente[0].paciente );
            
            
            setNumeroPantalla( numeroPantalla ); 

         

        }



        // setNumeroPantalla( numeroPantalla );
    }

    const nuevoTicket = async( tipoAtencion )=> {

        setTimeout(() => {
        }, 500);
       
        entidad= localStorage.getItem('entidad') || null;
        // if(entidad=== null) location.reload(); 
       
        

        const image =  new Image();
        image.src = await logoParaTicket;
        image.style.width= "60%";
        
        let numeroDocumento = document.getElementById('numeroDocumento');
        let documento= numeroDocumento.value;
        if(documento === "") return sweet("Atención!", 'Falta información', 'error');


        let selectDocumento = document.getElementById("tipoDocumento");
        let tipoDocumento= selectDocumento.value;
        if(tipoDocumento === "") return sweet("Atención!", 'Falta información', 'error');

        let chkPrioridad = document.getElementById("chkPrioridad");
        let indPrioridad = chkPrioridad.checked ? 1 : 0;

        
        setIsLoading(true);
        socket.emit('solicitar-ticket', { tipoDocumento, documento, indPrioridad, tipoAtencion, entidad }, ( result ) => {
            setIsLoading(false);
           
            numeroDocumento.value="";
            // documento="";
            selectDocumento.value="";
            tipoDocumento="";
            chkPrioridad.checked = false;
            indPrioridad= 0;

            // sweet('TICKET CREADO', '<h1> Turno: '+ tipoAtencion+"-"+ result.numero  + '</h1>'+ result.fecha, 'success');

            sweet('', `
                <div style="display: flex; flex-direction: column; align-items: center; padding: 5px">
                    ${iconSvg}        
                    <br/>
                    <b>
                        <h2> Turno: ${tipoAtencion} - ${result.numero} </h2>
                        <p>Por favor, esté atento al televisor o al llamado de voz para saber en qué módulo será atendido.</p> 
                        <br/>
                        ¡Gracias por su Atención!
                    </b>
                </div>
                `, 
                'success'
            );
            
            // let image =  new Image();
            // image.src = logo;
            // image.style.width= "50%";
            let mywindow = window.open(logoParaTicket, 'PRINT', 'height=200,width=300');
            
            mywindow.document.write('<html><head><title> </title></head>');
            mywindow.document.write('<body >');
            mywindow.document.write( image.outerHTML);
            mywindow.document.write('<h1> Turno: '+ tipoAtencion+"-"+ result.numero  + '</h1>');
            mywindow.document.write('<h4> Paciente: '+ documento  + '</h4>');
            mywindow.document.write('<h5> '+ result.fecha  + '</h5>');
            mywindow.document.write('<h6 style="text-align:end"> -- PITSoluciones.com -- </h6>');
            mywindow.document.write('</body>');
            mywindow.document.write('</html>');
    
            mywindow.document.close(); // necessary for IE >= 10 
            mywindow.focus(); // necessary for IE >= 10*/

            const myTimeout = setTimeout( () =>{
                
                // try {
                    mywindow.print();
                    mywindow.close();
                    clearTimeout(myTimeout);
                    
                // } catch (error) {
                //     clearTimeout(myTimeout);
                    
                // }

            }, 700);
    
            pasoPantalla( 1 );

        });
    }

    const cancelarTicket = () =>{

        let numeroDocumento = document.getElementById('numeroDocumento');
        numeroDocumento.value = "";
        let selectDocumento = document.getElementById("tipoDocumento");
        selectDocumento.value = ""


        let chkPrioridad = document.getElementById("chkPrioridad");
        chkPrioridad.checked = false;
        
        setPantalla(!pantalla);

    }

    const insertaNumero = (numero) => {
        let numeroDocumento = document.getElementById("numeroDocumento");
        if(numeroDocumento.value.length >= 12) return false;

        numeroDocumento.value += numero;
    }

    const borrarNumero = () => {
        let numeroDocumento = document.getElementById("numeroDocumento");

        numeroDocumento.value=  numeroDocumento.value.slice(0, -1);

    }



    if( entidad === null ){

        return (
            <div className="row">
                
    
                <div className="d-flex justify-content-center mb-5">
                    <div className='d-grid gap-2 col-lg-3 col-12 mx-auto'>
                        
                        <div className='col-12'>
                            <label htmlFor="codigoEntidad">Código Entidad</label>
                            <input 
                                type='text'
                                id= 'codigoEntidad' 
                                className='shadow form-control '
                                autoComplete='off' 
                                style={{ fontSize: 2+'em', textShadow: '2px 2px 8px #B8FFE9'}}
                            /> 

                        </div>

                        <div className='d-grid gap-2'>
                            <button className="btn btn-success btn-lg btn-block shadow" type="button" onClick={ () => ingresar()} >INGRESO</button>
                        </div>

                        
                    </div>
                </div>
            
            </div>
        )   
     

    } else{

        return(
            <>
                {isLoading && <LoadingOverlay />}
                <div className={` ${isLoading ? 'opacity' : ''} p-md-5 p-3`} style={{ height: '100dvh' }}>
                    
                    <div className="d-grid gap-2 mt-2 mx-auto text-center w-100 mb-3" >
                        <img id="imgPrint" className='img-fluid mx-auto d-block w-sm-50 w-md-30' style={{height:'auto'}} src={ logo } alt=''/>
                    </div>

                    

                    <div className='row content bg-light rounded-3' >
                        
                            <Collapse in={numeroPantalla === 1}>
                                <div className='row p-md-5 p-1 '>

                                    <div className='col-lg-6 col-12 text-center mb-5'>
                                                        
                                        <div className='ms-4 text-start col-12 px-4'>
                                            <label className='form-label text-muted fs-3' >Ingrese los datos del paciente para recibir el turno:</label>
                                        </div>
                                        <div className="card shadow-lg p-4 col-10 d-inline-block text-start justify-content-center" style={{ border: '0px', borderRadius: '15px', margin: 'auto' }}>
                                            
                                            <div className='card-body p-2 ' >

                                                
                                                <div className='col-12 '>

                                                    <div className='mb-5'>
                                                        <label className='form-label text-muted fs-3' >Tipo de documento</label>
                                                        <div className="input-group">
                                                            <span 
                                                                className="input-group-text  text-body-tertiary bg-white border-0 border-bottom rounded-0" 
                                                                style={{ borderBottom: '1px solid #eeeeee' }}
                                                            >
                                                                {/* <i className="bi bi-person-vcard text-body-tertiary"></i> */}
                                                                <i className="far fa-address-card text-body-tertiary fs-3" ></i>
                                                            </span>
                                                            <select
                                                                id="tipoDocumento"
                                                                className="form-select border-0 border-bottom rounded-0 fs-3"
                                                                style={{ borderBottom: '1px solid #eeeeee' }}
                                                                defaultValue="CC"
                                                            >
                                                                <option value="">Seleccione uno...</option>
                                                                <option value="RC">Registro Civil</option>
                                                                <option value="TI">Tarjeta de Identidad</option>
                                                                <option value="CC" >Cédula de Ciudadanía</option>
                                                                <option value="CE">Cédula de Extranjería</option>
                                                                <option value="PE">Permiso Especial de Permanencia</option>
                                                                <option value="PT">Permiso por Protección Temporal</option>
                                                            </select>
                                                        </div>
                                                    </div>       

                                                    <div className='mb-5'>
                                                        <label className='form-label text-muted fs-3 mb-0' >Número de documento</label>
                                                        <div className="input-group">
                                                            <span 
                                                                className="input-group-text  text-body-tertiary bg-white border-0 border-bottom rounded-0" 
                                                                style={{ borderBottom: '1px solid #eeeeee' }}
                                                            >
                                                            0 1 <br />
                                                            2 3
                                                            </span>
                                                            <input 
                                                                type='text'
                                                                inputMode="numeric"
                                                                pattern="[0-9]*"
                                                                id= 'numeroDocumento' 
                                                                className='form-control border-0 border-bottom rounded-0 fs-3'
                                                                autoComplete='off' 
                                                                style={{ borderBottom: '1px solid #eeeeee' }}
                                                                onKeyDown={(e) => {
                                                                    // Solo permite números
                                                                    console.log(e.target.value.length);
                                                                    
                                                                    if( e.target.value.length >= 12 ) {
                                                                        e.preventDefault()
                                                                        return;
                                                                    }else{

                                                                        e.target.value = e.target.value.replace(/[^0-9]/g, '');
                                                                    } 
                                                                }}
                                                            /> 

                                                        </div>
                                                    </div>
                                                    
                                                                                        
                                                </div>
                                                

                                                <div className="d-grid gap-2 col-xl-5 col-12 mx-auto ">
                                                    <button 
                                                        type="button" className="btn btn-lg btn-success m-1 rounded-5 " 
                                                        onClick={ () => pasoPantalla( 2 ) } 
                                                        style={{ fontSize: '30px' }}
                                                    > 
                                                        SIGUIENTE
                                                    </button>
                                                </div>
                                                
                                                
                                            </div>
                                        
                                        </div>    
                                    </div>
                                
                                    <div className='col-lg-6 col-12 text-start'>
                                        
                                            {[
                                                [1, 2, 3],
                                                [4, 5, 6],
                                                [7, 8, 9],
                                                [0]
                                            ].map((fila, idx) => (
                                                <div className="d-flex justify-content-center" key={idx}>
                                                    {fila.map(num => (
                                                        <button
                                                            key={num}
                                                            type="button"
                                                            className="btn btn-secondary btn-square-md m-1 shadow"
                                                            onClick={() => insertaNumero(num)}
                                                            value={num}
                                                        >
                                                            {num}
                                                        </button>
                                                    ))}
                                                    {idx === 3 && (
                                                        <button
                                                            type="button"
                                                            className="btn btn-outline-danger btn-rectangle-md m-1"
                                                            onClick={() => borrarNumero()}
                                                        >
                                                            Borrar
                                                        </button>
                                                    )}
                                                </div>
                                            ))}
                                        
                                        
                                            
                                    </div>
                                    
                                </div>
                            </Collapse>
                        
                            <Collapse in={numeroPantalla === 2}>
                                
                                <div className='col-12 py-2 fs-4 fw-bold'>
                                    
                                    <div className='row mb-2'>

                                        <div className="col-1">
                                            <button type="button" className="btn btn-sm btn-danger  m-1" onClick={ () => pasoPantalla( 1 ) } > Atrás </button>
                                        </div>
                                        
                                        <div className='col-11 text-center'>
                                            <label style={{  color: '#037faf' }}>  { `${numeroDocumentoPaso} ${pacientePaso ? '- ' + pacientePaso : '' }` } </label>
                                        </div>

                                        
                                    </div>
                                    
                                    <div className='col-lg-9 col-12 fs-3'>
                                        <label style={{  color: '#7A7A7A' }}> Indíquenos el motivo de su visita: </label>
                                    </div>

                                    <div className= 'row mt-1 pb-4' >
                                        <div className="d-flex justify-content-center mt-2">
                                            <div className='d-grid gap-1 col-lg-4 col-12 mx-auto mb-2'>
                                                <input type="checkbox" className="btn-check" id="chkPrioridad" autoComplete="off" />
                                                <label  
                                                    className="btn btn-lg btn-outline-danger rounded-5 border-1 shadow p-2" 
                                                    htmlFor="chkPrioridad"
                                                    style={{
                                                        fontFamily: "'Inter', sans-serif",
                                                        fontSize: "22px",
                                                        fontWeight: "700", // opcional si quieres variar entre bold y regular
                                                        
                                                    }}
                                                >
                                                     <i className="fa-solid fa-wheelchair"></i> 
                                                    <span className='ml-2'> PRIORIZADO </span>
                                                </label>
                                            </div>
                                        </div>

                                        {   tipoAtencion
                                            .map((item, i) => (
                                                <div className='col-lg-6 col-12 d-grid gap-3 mb-2 ' key={ item.uidTipoAtencion }>
                                                    
                                                    <div 
                                                        className={ 
                                                            `
                                                                card m-2 hover-shadow 
                                                                ${isTouched ? 'card-touch-active' : ''}
                                                                rounded-4 shadow-lg
                                                                border-bottom-2 
                                                                min-h-[120px] sm:min-h-[150px] md:min-h-[80px] lg:min-h-[200px]
                                                            ` 

                                                        } 
                                                        style={{ cursor: 'pointer', borderBottomColor: item.color ?? '#000' }}
                                                        onClick={ () => nuevoTicket(`${item.codigoTipoAtencion}`)}
                                                        onTouchStart={handleTouchStart}
                                                        onTouchEnd={handleTouchEnd}
                                                        onTouchCancel={handleTouchEnd}
                                                        role="button"
                                                        tabIndex={0}
                                                    >
                                                        <div className="card-body">
                                                            <div className='row mx-auto p-2'>

                                                                <div className="col-1  d-flex align-items-center justify-content-center">
                                                                    <i 
                                                                        className={`${item.icono} fa-3x`}
                                                                        style={{ color: item.color ?? '#000' }}
                                                                    ></i>
                                                                </div>
                                                                <div className="col-11">
                                                                    <div 
                                                                        className="d-flex flex-column justify-content-start align-items-start text-start p-2 ms-2 p-2 ms-2"
                                                                        style={{
                                                                            fontFamily: "'Inter', sans-serif",
                                                                            fontSize: "18px",
                                                                            fontWeight: "700", // opcional si quieres variar entre bold y regular
                                                                            
                                                                        }}
                                                                    >
                                                                        <span>
                                                                            { item.tipoAtencion } 
                                                                        </span>
                                                                        <span style={{ fontSize: "18px", color: '#7A7A7A', fontWeight: '300' }} >
                                                                            { item.complemento } 
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    {/* <button 
                                                        
                                                        className= {`btn btn-${colores[ can === colores.length-1 ? can= 0 : can=can+1 ]} p-3`}
                                                        style={{ fontSize: '1.2 rem', fontWeight: 'bolder' }}
                                                        onClick={ () => nuevoTicket(`${item.codigoTipoAtencion}`)}
                                                    > 
                                                        <i className={`${item.icono} fa-2x`}></i> <br /> <br />
                                                        { item.tipoAtencion } 
                                                    </button> */}

                                                </div>
                                            )
                                            
                                            
                                            )
                                        }

                                        
                                    </div>

                                    {/* <div className="d-grid gap-2"> */}
                                        {/* <button className="shadow btn btn-lg btn-success"   type="button" onClick={ () => nuevoTicket("C")} ><i className="fa-solid fa-heart-pulse"></i> <br /> CITAS PROGRAMADAS</button>
                                        <button className="shadow btn btn-lg btn-primary"   type="button" onClick={ () => nuevoTicket("S")} ><i className="fa-solid fa-calendar-check"></i> <br /> SOLICITUD DE CITAS</button>
                                        <button className="shadow btn btn-lg btn-warning"   type="button" onClick={ () => nuevoTicket("H")} ><i className="fa-solid fa-address-book"></i> <br /> SOLICITUD DE HISTORIA CLÍNICA  Y ENTREGA DE RESULTADOS</button>
                                        <button className="shadow btn btn-lg btn-info"      type="button" onClick={ () => nuevoTicket("E")} ><i className="fa-solid fa-user-nurse"></i> <br /> ENFERMERÍA</button> */}
                                        {/* <button className="btn btn-lg btn-primary" type="button" onClick={ () => nuevoTicket("A")}>ATENCIÓN PRIORIZADA</button> */}
                                        {/* <button className="shadow btn btn-lg btn-danger" type="button" onClick={ () => nuevoTicket("P")} ><i className="fa-solid fa-user-tie"></i> <br /> PARTICULAR - MEDICINA PREPAGADA - ECOPETROL</button> */}
                                    {/* </div> */}

                                    

                                </div>

                            </Collapse>

                        </div>
                        
                    

                    

                     
                
                </div>
            </>

        ) 

    }
    
}
